var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "56px",
    height: "56px",
    viewBox: "0 0 56 56",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 56 56"
    },
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.4,51.1c-5-1.8-9.4-3-13.4-3.8v-3.8c7.2-0.7,12.8-6.8,12.8-14.1c0-7.8-6.4-14.2-14.2-14.2c-1.2,0-2.3,0.1-3.4,0.4  C29.5,8.4,23.5,3,19.3,3C14.5,3,7.1,10.2,7.1,19.2c0,8.5,5,15.4,11.2,16.1v11.1C10,47.6,6.5,51,6.2,51.3c-0.4,0.4-0.4,1,0,1.4  c0.4,0.4,1,0.4,1.4,0c0.1-0.1,10.8-10.6,41,0.2c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7C50.2,51.8,49.9,51.2,49.4,51.1z   M34.5,17.1c6.7,0,12.2,5.5,12.2,12.2c0,6.3-4.7,11.4-10.8,12.1v-3.6l6.9-6.9c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L35.9,35V24.9  c0-0.6-0.4-1-1-1s-1,0.4-1,1V35l-3-3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4l4.4,4.4v3.6c-4.6-0.2-8.6-3-10.5-7.1  c4.7-2.2,8.1-8.2,8.1-15.2c0-0.6,0-1.1-0.1-1.7C32.5,17.2,33.5,17.1,34.5,17.1z M9.1,19.2C9.1,11.5,15.4,5,19.3,5  s10.3,6.5,10.3,14.2c0,7.3-4.1,13.4-9.3,14.1v-2.5l5.1-5.1c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-3.7,3.7v-2.5c0,0,0,0,0,0V22l5.2-5.2  c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0l-3.8,3.8v-4.6c0-0.6-0.4-1-1-1s-1,0.4-1,1v8.3l-4.7-4.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4  l6.1,6.1v7.5C13.1,32.6,9.1,26.5,9.1,19.2z M20.3,46.1V35.3c0.4,0,0.8-0.1,1.2-0.2c2.2,4.9,7,8.2,12.4,8.5v3.4  C28.5,45.9,24,45.8,20.3,46.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.b53fa9e6e0cf5afddd06901be2fdf572.svg";
export { ForwardRef as ReactComponent };